import { Fragment } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import SelectCell from "./SelectCell";
import InputCell from "./InputCell";
import { STATIC_STRINGS } from "../../../../../utils/Constants";
import { QuestionChangeParams } from "../types";
import { SIZES, TEXT_ALIGN } from "../../../../../utils/enums";

const questionTypesDropdown = STATIC_STRINGS.QUESTION_TYPES_DROPDOWN;
const headerCells = [
  STATIC_STRINGS.TOPIC,
  STATIC_STRINGS.QUESTION_TYPE,
  STATIC_STRINGS.DIFFICULTY_LEVEL,
  STATIC_STRINGS.NUMBER_OF_QUESTIONS,
  STATIC_STRINGS.ADDITIONAL_REQUIREMENTS,
  STATIC_STRINGS.TABLE_HEADERS.ACTIONS,
];

const RenderTable = ({
  topicsData,
  setTopicsData,
  setModalOpen,
  setNewQuestion,
}) => {
  const updateQuestionProperty = ({
    topicIndex,
    questionIndex,
    key,
    newValue,
  }: QuestionChangeParams) => {
    setTopicsData((prevTopics) =>
      prevTopics.map((topic, i) =>
        i === topicIndex
          ? {
              ...topic,
              questionTypes: topic.questionTypes.map((question, j) =>
                j === questionIndex
                  ? { ...question, [key]: newValue }
                  : question
              ),
            }
          : topic
      )
    );
  };

  const handleChange = ({
    topicIndex,
    questionIndex,
    key,
    newValue,
  }: QuestionChangeParams) => {
    if (key === "numberOfQuestions") {
      const parsedValue = parseInt(newValue as string);
      newValue = isNaN(parsedValue) ? 0 : Math.max(0, parsedValue);
    }
    updateQuestionProperty({ topicIndex, questionIndex, key, newValue });
  };

  const handleDeleteType = (topicIndex: number, questionIndex: number) => {
    setTopicsData((prevTopics) =>
      prevTopics.map((topic, i) =>
        i === topicIndex
          ? {
              ...topic,
              questionTypes: topic.questionTypes.filter(
                (_, j) => j !== questionIndex
              ),
            }
          : topic
      )
    );
  };

  return (
    <TableContainer component={Paper}>
      <Table stickyHeader size={SIZES.sm}>
        <TableHead>
          <TableRow>
            {headerCells.map((label) => (
              <TableCell key={label} align="center" sx={{ fontWeight: "bold" }}>
                {label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {topicsData.map((topic, topicIndex) => (
            <Fragment key={topicIndex}>
              <TableRow>
                <TableCell
                  rowSpan={topic.questionTypes.length + 2}
                  align="center"
                >
                  {topic.topic} : <br /> {topic.subtopic}
                </TableCell>
              </TableRow>
              {topic.questionTypes.map((question, questionIndex) => (
                <TableRow key={questionIndex}>
                  <SelectCell
                    value={question.questionType}
                    onChangeHandler={(e) =>
                      handleChange({
                        topicIndex,
                        questionIndex,
                        key: "questionType",
                        newValue: e.target.value,
                      })
                    }
                    options={questionTypesDropdown.map((type) => ({
                      label: type,
                      value: type,
                    }))}
                  />
                  <SelectCell
                    value={question.difficultyLevel}
                    onChangeHandler={(e) =>
                      handleChange({
                        topicIndex,
                        questionIndex,
                        key: "difficultyLevel",
                        newValue: e.target.value,
                      })
                    }
                    options={[
                      {
                        value: STATIC_STRINGS.EASY,
                        label: STATIC_STRINGS.EASY,
                      },
                      {
                        value: STATIC_STRINGS.MEDIUM,
                        label: STATIC_STRINGS.MEDIUM,
                      },
                      {
                        value: STATIC_STRINGS.HARD,
                        label: STATIC_STRINGS.HARD,
                      },
                    ]}
                  />
                  <InputCell
                    type="number"
                    value={question.numberOfQuestions.toString()}
                    onChangeHandler={(e) =>
                      handleChange({
                        topicIndex,
                        questionIndex,
                        key: "numberOfQuestions",
                        newValue: e.target.value,
                      })
                    }
                    className="w-2/3 lg:w-1/2"
                    textAlign={TEXT_ALIGN.center}
                  />
                  <InputCell
                    type="text"
                    value={question.additionalFeedback ?? ""}
                    onChangeHandler={(e) =>
                      handleChange({
                        topicIndex,
                        questionIndex,
                        key: "additionalFeedback",
                        newValue: e.target.value,
                      })
                    }
                  />
                  <TableCell align="center">
                    <button
                      className="btn btn-outline p-2"
                      onClick={() =>
                        handleDeleteType(topicIndex, questionIndex)
                      }
                    >
                      {STATIC_STRINGS.DELETE}
                    </button>
                  </TableCell>
                </TableRow>
              ))}
              <TableRow>
                <TableCell colSpan={5} align="right">
                  <button
                    className="btn btn-outline p-2"
                    onClick={() => {
                      setNewQuestion((p) => ({ ...p, index: topicIndex }));
                      setModalOpen("open");
                    }}
                  >
                    {STATIC_STRINGS.ADD_TYPE}
                  </button>
                </TableCell>
              </TableRow>
            </Fragment>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
export default RenderTable;
